import IInputMaskItem, { MaskValue } from './IInputMaskItem';

export default class InputMaskPlusMinus extends IInputMaskItem {
    mask: string;

    constructor() {
        super();

        this.mask = '±';
        this.maskValue = [new MaskValue('+')];
    }

    addUserInput(char: string, charIndex: number): boolean {
        if (char.length != 1) {
            return false;
        }

        // We only accept + or - as input
        if (char != '-') {
            char = '+';
        }

        if (this.maskValue?.length > 0) {
            this.maskValue[0]!.userValue = char;
        }

        return true;
    }

    removeUserInput(charIndex: number): boolean {
        if (charIndex < 0 || charIndex > this.maskValue.length) {
            throw new Error(`Mask index cannot be out of bounds. Index: ${charIndex}, maskLength: ${this.maskValue.length}`);
        }

        if (this.maskValue[charIndex].userValue == null) {
            return false;
        }

        this.maskValue[charIndex].userValue = null;

        return true;
    }

    /**
     * Return the uservalue if filled, or else the placeholder value
     * @returns
     */
    getCurrentDisplayValue(): string {
        return this.maskValue.reduce((res, mv) => res + (mv.userValue || mv.placeHolder), '');
    }

    /**
     * This will return empty string where the userValue is not filled
     * @returns
     */
    getCurrentTextForInputElement(): string {
        return this.maskValue.reduce((res, mv) => res + (mv.userValue || ' '), '');
    }

    /**
     * Check if the user value is filled.
     * @returns
     */
    isMaskFilled(): boolean {
        return this.maskValue.every((mi) => mi.userValue);
    }
}
